export const shouldHideSender = (country) => country === 'br';
